export class FacturaSeleccion {
    periodoCodigo: string;
    contratoCodigo: string;
    contratoVersion: string;
    version: string;
    firmarFactura: boolean;
    duplicado: boolean;
    waterMarkImageFilePath: string;
  }


// WEBPACK FOOTER //
// C:/Users/jboix/source/repos/classic/OficinaAngular/src/app/entities/facturaSeleccion.entity.ts